<!-- <app-mail-list (newItemEvent)="switchView($event)" [claimIdInput]="claimDetailsSend" (mailDetailsEvent)="fetchMailDetails($event)" (refreshMail)="refresh($event)" (closeMailBox)="closeMail($event)" *ngIf="view === 'list'"></app-mail-list>
<app-mail-details (newItemEvent)="switchView($event)" [claimDetailsFetch]="claimDetailsSend" [claimData]="mailDetails" (refreshEvent)="refresh($event)" *ngIf="view === 'details'"></app-mail-details> -->



<div class="row row_flex mt-0">
  <div class="col-md-6">
    <!--<button
      mat-raised-button
      color="primary"
      class="save_secondary"
      cdkFocusInitial
    >
      <mat-icon>edit</mat-icon>Compose
    </button>-->
  </div>
  <div class="col-md-6">
    <span mat-dialog-close matSuffix class="float-right" (click)="closeMail('false')">
      <mat-icon style="color: #0E35E6;">close</mat-icon>
    </span>
  </div>
</div>
<div class="row">
  <div class="col-md-12 invoicenames">
    <span class="MM18 tableNames">
      Notifications
    </span>
  </div>
</div>
<ng-container *ngIf="spinner">
  <div style="margin: 13rem;"><mat-spinner ></mat-spinner>  </div>

</ng-container>
<ng-container *ngIf="!spinner">

<ng-container *ngFor="let item of notification">
<div class="  card box-shadow card_flex row_flex" style="margin: 1rem 0px;" > 
  <div class="row">
    <div *ngIf="!item.isAsignable" class="col-md-12 "><mat-icon (click)="openClaimDetails(item.tcClaimNumber,'view')" style="cursor: pointer;float: right;">remove_red_eye</mat-icon></div>
    <div *ngIf="item.isAsignable" class="col-md-12 " ><mat-icon (click)="openClaimDetails(item.tcClaimNumber,'assign')" style="cursor: pointer;float: right;">input</mat-icon></div>
    <div class="col-md-6">
      <div><span class="MM12 notNames p-2">Claim Id : </span></div>
      <div class="MM12 ansNames p-2">{{item.claimId}}</div>
    </div>
    <div class="col-md-6">
      <div><span  class="MM12 notNames p-2">Patient Name :</span></div>
      <div class="MM12 ansNames p-2">{{item.patientName}} </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
     
      <div><span class="MM12 notNames p-2">Claim Status From :</span></div>
      <div class="MM12 ansNames p-2">{{item.claimStatusFrom}}</div>
    </div>
    <div class="col-md-6">
   
      <div><span class="MM12 notNames p-2">Claim Status To :</span></div>
      <div class="MM12 ansNames p-2">{{item.claimStatusTo}}</div>
    </div>
  </div>
</div>
</ng-container>  
</ng-container>